import { getPrefixUrl } from '@/utils/globalData'

const ONLINE_VISIT_INTERVAL_MS = 45 * 1000
const ONLINE_VISIT_TIMER_KEY = '__onlineVisitTimer__'
const ONLINE_VISIT_UNLOAD_KEY = '__onlineVisitUnloadHandler__'
const ONLINE_VISIT_ENDPOINT = '/mall/admin/online/recordVisit'

const getDomainForVisit = () => {
  if (!process.client) return ''

  const redirectSubDomain = sessionStorage.getItem('redirectSubDomain') || ''
  return redirectSubDomain || window.location.host || ''
}

const buildPayload = (domain) => ({
  param: {
    domain
  }
})

export default defineNuxtPlugin((nuxtApp) => {
  if (!process.client) return

  const domain = getDomainForVisit()
  if (!domain) return

  const sendVisit = async () => {
    try {
      await nuxtApp.$customFetch(ONLINE_VISIT_ENDPOINT, {
        method: 'POST',
        body: buildPayload(domain)
      })
    } catch (error) {
      // 忽略心跳上报错误，避免影响主流程
    }
  }

  const sendVisitOnUnload = () => {
    const url = `${getPrefixUrl()}${ONLINE_VISIT_ENDPOINT}`
    const body = JSON.stringify(buildPayload(domain))

    try {
      if (navigator.sendBeacon) {
        const blob = new Blob([body], { type: 'application/json' })
        navigator.sendBeacon(url, blob)
        return
      }

      fetch(url, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body,
        keepalive: true
      }).catch(() => {})
    } catch (error) {
      // no-op
    }
  }

  // 避免热更新或重复初始化时产生多个定时器
  if (window[ONLINE_VISIT_TIMER_KEY]) {
    clearInterval(window[ONLINE_VISIT_TIMER_KEY])
  }

  const timerId = window.setInterval(() => {
    sendVisit()
  }, ONLINE_VISIT_INTERVAL_MS)

  window[ONLINE_VISIT_TIMER_KEY] = timerId

  // 首次进入先上报一次
  sendVisit()

  const unloadHandler = () => {
    sendVisitOnUnload()

    if (window[ONLINE_VISIT_TIMER_KEY]) {
      clearInterval(window[ONLINE_VISIT_TIMER_KEY])
      window[ONLINE_VISIT_TIMER_KEY] = null
    }

    if (window[ONLINE_VISIT_UNLOAD_KEY]) {
      window.removeEventListener('beforeunload', window[ONLINE_VISIT_UNLOAD_KEY])
      window.removeEventListener('pagehide', window[ONLINE_VISIT_UNLOAD_KEY])
      window[ONLINE_VISIT_UNLOAD_KEY] = null
    }
  }

  if (window[ONLINE_VISIT_UNLOAD_KEY]) {
    window.removeEventListener('beforeunload', window[ONLINE_VISIT_UNLOAD_KEY])
    window.removeEventListener('pagehide', window[ONLINE_VISIT_UNLOAD_KEY])
  }

  window[ONLINE_VISIT_UNLOAD_KEY] = unloadHandler
  window.addEventListener('beforeunload', unloadHandler)
  window.addEventListener('pagehide', unloadHandler)
})
